import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { DocPreviewUtilityService } from '../doc-preview-utility.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'main [app-pdf-reader]',
  templateUrl: './pdf-reader.component.html',
  host: { '[attr.id]': '\'content\'' },
  styleUrls: ['./pdf-reader.component.css']
})
export class PdfReaderComponent {
  pdfSrc: Uint8Array | undefined;
  page = 1;
  nomeFile: string = null;
  documentoId: string = null;
  cloneBuffer: any = null;
  totalPages = 0;
  zoom = 0.6;
  @ViewChild('pdfContainer') pdfContainer!: ElementRef;
  constructor(
    private helpers: HelpersService,
    private route: ActivatedRoute,
    private router: Router,
    private viewManager: ViewManagerService,
    private docUtilityService: DocPreviewUtilityService,
    private title: Title
  ) { }

  ngOnInit() {
    this.viewManager.svuotaMenu();
    this.viewManager.showHeader();
    this.nomeFile = this.route.snapshot.queryParamMap.get('nomeFile');
    this.documentoId = this.route.snapshot.paramMap.get('idDocumento')!;
    window.opener?.postMessage('child_ready', window.location.origin);
    window.addEventListener('message', this.onMessageReceived.bind(this), false);
    this.title.setTitle("Teleforum - " + this.nomeFile);
    this.route.data.subscribe(data => {
      if (!!data['documento'] && typeof data['documento'] === "object") {
        this.pdfSrc = new Uint8Array(data["documento"]);
        this.cloneBuffer = data["documento"].slice(0);
        // this.loadPdf(data["documento"]);
      }
    });
  }

  onMessageReceived(event: MessageEvent) {
    if (event.origin !== window.location.origin) {
      console.warn('Origine non valida:', event.origin);
      return;
    }
    const content = event?.data?.content;
    if (!!content) {
      this.nomeFile = event?.data?.name;
      this.cloneBuffer = content.slice(0);
      // this.loadPdf(content);
      const byteArray = this.docUtilityService.base64ToUint8Array(content);
      this.pdfSrc = byteArray;

    }
  }

  afterLoadComplete(pdf: any) {
    this.totalPages = pdf.numPages;
  }


  // loadPdf(content) {
  //   const pdfUrl = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  //   this.http.get(pdfUrl, { responseType: 'arraybuffer' }).subscribe({
  //     next: (arrayBuffer) => {
  //       console.log(arrayBuffer, 'array buffer')
  //       this.pdfSrc = new Uint8Array(content);
  //     },
  //     error: (err) => {
  //       console.error('Errore caricamento PDF:', err);
  //     }
  //   });
  // }

  nextPage() {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
    }
  }


  zoomIn() {
    this.zoom = Math.min(this.zoom + 0.1, 5); // zoom max a 5x
  }

  zoomOut() {
    this.zoom = Math.max(this.zoom - 0.1, 0.5); // zoom min a 0.5x
  }

  onScroll() {
    const container = this.pdfContainer.nativeElement;
    const canvasList = container.querySelectorAll('canvas');

    for (let i = 0; i < canvasList.length; i++) {
      const canvas = canvasList[i] as HTMLCanvasElement;
      const rect = canvas.getBoundingClientRect();

      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        this.page = i + 1;
        break;
      }
    }
  }

  goToPage(event: Event) {
    const input = event.target as HTMLInputElement;
    const pageNumber = Number(input.value);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.page = pageNumber;
    } else {
      input.value = this.page.toString(); // reset valore se fuori range
    }
  }

  downloadPdf() {
    if (!!this.documentoId && this.documentoId !== "buffer") {
      this.helpers.downloadDocument(this.documentoId).subscribe();
    } else {
      // Converte la base64 in Uint8Array
      const byteArray = this.docUtilityService.base64ToUint8Array(this.cloneBuffer);

      // Crea un Blob con i dati binari
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      // Crea un URL per il Blob
      const url = window.URL.createObjectURL(blob);
      
      // Crea il link di download
      const a = document.createElement('a');
      a.href = url;
      a.download = this.nomeFile || 'documento.pdf';  // Usa nomeFile se disponibile
      a.click();
      
      // Rimuove l'oggetto URL
      window.URL.revokeObjectURL(url);
    }
  }

  printPdf() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Edg/")) {
      this.printPdfEdge();
      return
    }
    if (!this.cloneBuffer) {
      console.warn('Nessun PDF caricato da stampare.');
      return;
    }

    const byteArray = this.cloneBuffer instanceof ArrayBuffer ? this.cloneBuffer : this.docUtilityService.base64ToUint8Array(this.cloneBuffer);
      // Crea un Blob con i dati binari
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = url;

    document.body.appendChild(iframe);

    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();

        // Pulizia: rimuovi iframe e revoca URL dopo la stampa
        // setTimeout(() => {
        //   document.body.removeChild(iframe);
        //   URL.revokeObjectURL(url);
        // }, 1000);
      }, 500);
    };
  }

  printPdfEdge() {
    if (!this.cloneBuffer) {
      console.warn('Nessun PDF caricato da stampare.');
      return;
    }

    const byteArray = this.cloneBuffer instanceof ArrayBuffer ? this.cloneBuffer : this.docUtilityService.base64ToUint8Array(this.cloneBuffer);
    // Crea un Blob con i dati binari
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    // const blob = new Blob([this.cloneBuffer], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const newWindow = window.open(url, '_blank');

    if (!newWindow) {
      console.error('Impossibile aprire una nuova finestra. Popup bloccato?');
      return;
    }

    // Alcuni browser richiedono un delay per consentire il caricamento completo del PDF
    const tryPrint = () => {
      if (newWindow.document.readyState === 'complete') {
        newWindow.focus();
        newWindow.print();
      } else {
        setTimeout(tryPrint, 500); // riprova finché la finestra non è pronta
      }
    };

    // Aspetta un attimo per essere sicuro che il contenuto sia caricato
    setTimeout(tryPrint, 1000);
  }



  
  onPageChange(page: number): void {
    this.page = page;
    console.log('Pagina attuale:', this.page);
  }
}
